import EntryPoint from 'Engine/EntryPoint';

export default class MovieClipsAccessor {
  constructor() {
    EntryPoint.MovieClipsAccessor = this;
    this.movieClips = new Map();
  }

  getMovieClip(type) {
    return this.movieClips.get(type);
  }

  setMovieClip(type, value) {
    this.movieClips.set(type, value)
  }
}
